import { combineReducers } from 'redux';
import { routeReducer as router } from 'react-router-redux';
import appState from './reducers/appStateReducer';
import baseState from './reducers/baseStateReducer';
import customControl from './reducers/customControlReducer';
import dimensionsEntities from './reducers/dimensionsEntitiesReducer';
import dimensionsResult from './reducers/dimensionsResultReducer';
import modal from './reducers/modalReducer';
import popover from './reducers/popoverReducer';
import search from './reducers/searchReducer';
import featureFlags from './reducers/featureFlagsReducer';

export default combineReducers({
  appState,
  baseState,
  customControl,
  dimensionsEntities,
  dimensionsResult,
  featureFlags,
  modal,
  popover,
  router,
  search,
});



/** WEBPACK FOOTER **
 ** ./src/redux/rootSearchUnitReducer.js
 **/